import { useState } from "react";
import { addHotel } from "../slices/tourSlice";
import { useDispatch, useSelector } from "react-redux";
import Success from "./success";

const HotelModal = ({ isOpen, onClose, selectedTour }) => {
  const { status } = useSelector((state) => state.tours);
  const dispatch = useDispatch();

  const [hotels, setHotels] = useState([
    { name: "", price: "", tourId: selectedTour.id },
  ]);
  const [success, setIsSuccess] = useState(false);

  const handleHotelChange = (index, field, value) => {
    const updatedHotels = [...hotels];
    updatedHotels[index][field] = value;
    setHotels(updatedHotels);
  };

  const handleAddHotelField = () => {
    setHotels([...hotels, { name: "", price: "", tourId: selectedTour.id }]);
  };

  const handleRemoveHotelField = (index) => {
    const updatedHotels = hotels.filter((_, i) => i !== index);
    setHotels(updatedHotels);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await dispatch(addHotel(hotels)); // list göndəririk
    if (status === "succeeded") {
      setIsSuccess(true);
    }
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content add-modal-for-tour">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>Otel(lər) əlavə et</h2>
        <form onSubmit={handleSubmit}>
          {hotels.map((hotel, index) => (
            <div key={index} style={{marginBottom: "10px" }}>
              <input
                type="text"
                name="name"
                placeholder="Başlıq"
                value={hotel.name}
                onChange={(e) =>
                  handleHotelChange(index, "name", e.target.value)
                }
                required
              />
              <input
                type="number"
                name="price"
                placeholder="Qiymət"
                style={{ width: "6vw" }}
                value={hotel.price}
                onChange={(e) =>
                  handleHotelChange(index, "price", e.target.value)
                }
                required
              />
              {hotels.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveHotelField(index)}
                >
                  Sil
                </button>
              )}
            </div>
          ))}

          <a style={{fontSize:"1.3vw",cursor:"pointer",marginRight:"auto",padding:"0.5vw",backgroundColor:"#616161",borderRadius:"0.5vw",color:"#ffffff"}} onClick={handleAddHotelField}>
            Əlavə Et
          </a>

          <button type="submit" className="submit-btn">
            Otelləri əlavə et
          </button>
        </form>
      </div>

      {success && (
        <Success isOpen={success} onClose={() => setIsSuccess(false)} />
      )}
    </div>
  );
};

export default HotelModal;